





import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    }
})
export default class StandByScreen extends Vue 
{
    private isVisible = false;

    public open(completion : () => void)
    {
        this.isVisible = true;
        // 0.03s の遅延を行わないと、ウェイトカーソルにならない
        setTimeout(() =>
        {
            this.isVisible = false;
            completion();
        }, 30);
    }
}
